module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "render-list"
  }, [_c('CommonHeader', {
    attrs: {
      "curNavIndex": _vm.curNavIndex
    }
  }), _vm._v(" "), _c('CommonSearch'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('CommonFooter'), _vm._v(" "), _c('div', {
    staticClass: "error-tip",
    attrs: {
      "id": "J_ErrorTip"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iscroll-list work-list",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "scroller"
    }
  }, [_c('div', {
    staticClass: "ui-refresh-down",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "J_PullDown"
    }
  }, [_c('span', {
    staticClass: "refresh-down-label"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "thelist"
    }
  }, [_c('img', {
    staticClass: "loading-img",
    attrs: {
      "src": require("../../static/img/loading.gif")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui-refresh-up",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "J_PullUp"
    }
  }, [_c('span', {
    staticClass: "refresh-up-label"
  }, [_vm._v("More")]), _c('img', {
    staticClass: "pull-up-img",
    attrs: {
      "src": require("../../static/img/loading.gif")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49c17150"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Works.vue
// module id = 132
// module chunks = 1